import React from "react";
import { recordRumError } from "../utils/rum";

/**
 * React レンダーエラーを CloudWatch RUM に記録する ErrorBoundary。
 * レンダリング中の例外のみ捕捉する（非同期エラーは aws-rum-web の自動フックが担当）。
 */
class RumErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    recordRumError(error, {
      kind: "react_render",
      componentStack: info.componentStack,
    });
  }

  render() {
    // ErrorBoundary 自身はフォールバック UI を持たず、子をそのままレンダー。
    // エラー発生時は hasError=true になるが、このコンポーネントのレンダーエラーは
    // 上位のハンドラ（location.href = "/Error" 等）に任せる。
    const { children } = this.props;
    return children;
  }
}

export default RumErrorBoundary;
